function _isEmptyInput(input) {
  if (typeof input === "object") {
    return Object.keys(input).length === 0 || Object.keys(input).every((key) => _isEmptyInput(input[key]));
  }
  return !input;
}

export function getWeights(
  input,
  template,
  fullScore,
  ignoreExclusive = false,
  ignoreRequired = false
) {
  const weights = {};

  // all keys should be found in template
  if (!Object.keys(input).every((key) => key in template)) return null;

  const totalWeight = Object.keys(input).reduce((tot, key) => {
    if (
      (typeof input[key] === "object" && !_isEmptyInput(input[key])) ||
      input[key] === true
    )
      return (
        tot +
        (template[key].mustSatisfy
          ? 0
          : template[key].score
            ? template[key].score
            : 1)
      );
    else return tot;
  }, 0);

  Object.keys(input).forEach((key) => {
    const numSelectedChildren = Object.keys(input[key]).reduce(
      (acc, cur) => (input[key][cur] ? acc + 1 : acc),
      0
    );

    let selfScore = null;
    if (template[key].mustSatisfy || fullScore < 0) {
      // if (template[key].children && numSelectedChildren === 0) {
      //   weights[key] = null;
      //   return;
      // }
      selfScore = -1;
    } else {
      const selfWeight = template[key].score ? template[key].score : 1;
      selfScore = (fullScore / totalWeight) * selfWeight;
    }

    if (!ignoreRequired && template[key].required && numSelectedChildren === 0) {
      weights[key] = null;
      return;
    }

    if (
      !ignoreExclusive &&
      template[key].exclusive &&
      numSelectedChildren > 1
    ) {
      weights[key] = null;
      return;
    }

    weights[key] = template[key].children
      ? getWeights(input[key], template[key].children, selfScore)
      : input[key]
        ? selfScore
        : 0;
  });
  return weights;
}

// weightedInput and toolCapability should both be valid
export function getScore(weightedInput, toolCapability) {
  const result = { detail: {} };
  result.score = Object.keys(weightedInput).reduce((acc, cur) => {
    if (typeof weightedInput[cur] === "number") {
      const localCap = (toolCapability && toolCapability[cur]) ?? 0;
      result.detail[cur] = {
        score:
          weightedInput[cur] >= 0
            ? weightedInput[cur] * localCap
            : weightedInput[cur] * (1 - localCap),
      };
    } else {
      result.detail[cur] = getScore(
        weightedInput[cur],
        toolCapability && toolCapability[cur]
      );
    }
    const selfScore = result.detail[cur].score;
    return selfScore * acc >= 0 ? selfScore + acc : Math.min(selfScore, acc);
  }, 0);
  return result;
}
